<template>
  <TabView>
    <TabPanel header="Gởi tin nhắn thông thường">
      <div id="tabs_tn1" class="py-1">
        <div class="w-full p-0">
          <div class="grid grid-cols-1 gap-[18px] items-start md:grid-cols-12">
            <div class="flex min-w-0 flex-col md:col-span-6">
              <label>Lựa chọn phạm vi gởi tin nhắn</label>
              <Dropdown
                id="kind"
                v-model="action"
                :options="lsAction"
                optionLabel="label"
                optionValue="value"
              >
              </Dropdown>
            </div>
            <div
              class="flex min-w-0 flex-col md:col-span-6"
              v-if="action == 'location'"
            >
              <label>Lựa chọn khu vực gởi tin</label>
              <Dropdown
                id="location"
                v-model="province"
                :options="listProvince"
                optionLabel="provinceName"
                optionValue="provinceCode"
                :filter="true"
                :showClear="true"
              >
              </Dropdown>
            </div>
            <div
              class="flex min-w-0 flex-col md:col-span-6"
              v-if="action == 'gender'"
            >
              <label>A3. Giới tính </label>
              <div
                class="flex min-h-[42px] items-center gap-4 rounded-lg border border-slate-300 bg-white px-3"
              >
                <div class="flex items-center gap-2">
                  <input
                    class="m-0 h-4 w-4 accent-teal-600"
                    type="radio"
                    id="nam"
                    name="sex"
                    value="Nam"
                    v-model="gender"
                  />
                  <label
                    for="nam"
                    class="m-0 min-h-0 font-semibold leading-none text-slate-900"
                    >Nam</label
                  >
                </div>
                <div class="flex items-center gap-2">
                  <input
                    class="m-0 h-4 w-4 accent-teal-600"
                    type="radio"
                    id="nu"
                    name="sex"
                    value="Nữ"
                    v-model="gender"
                  />
                  <label
                    for="nu"
                    class="m-0 min-h-0 font-semibold leading-none text-slate-900"
                    >Nữ</label
                  >
                </div>
              </div>
            </div>
            <div
              class="flex min-w-0 flex-col md:col-span-6"
              v-if="action == 'customer'"
            >
              <label>Chọn khách hàng gởi</label>
              <MultiSelect
                v-model="listIdMessage"
                :options="listCustomer"
                optionLabel="name"
                placeholder="Chọn tài khoản"
                :filter="true"
              >
                <template #option="slotProps">
                  <div class="flex items-center gap-2">
                    <img
                      v-if="slotProps.option.imageUrl"
                      :src="slotProps.option.imageUrl"
                      class="h-10 w-10 rounded-md object-cover"
                    />
                    <label class="m-0 font-medium text-slate-800">{{
                      slotProps.option.name
                    }}</label>
                  </div>
                </template>
              </MultiSelect>
              <!--              <small id="id-note1" class="block min-h-[18px] text-xs font-medium text-red-500"-->
              <!--                >* Vui lòng chọn danh sách khách hàng gởi</small-->
              <!--              >-->
            </div>
            <div
              class="flex min-w-0 flex-col md:col-span-6"
              v-if="action == 'age'"
            >
              <label>Chọn phạm vi độ tuổi: {{ age }}</label>
              <h5></h5>
              <Slider v-model="age" :range="true" />
            </div>
            <div
              class="flex min-w-0 flex-col md:col-span-6"
              v-if="action == 'group'"
            >
              <label>Lựa chọn nhóm gởi tin</label>
              <Dropdown
                id="group"
                v-model="idGroup"
                :options="listGroup"
                optionLabel="groupName"
                optionValue="id"
                :filter="true"
                :showClear="true"
              >
              </Dropdown>
            </div>
            <div
              class="flex min-w-0 flex-col md:col-span-6"
              v-if="action == 'civilgroup'"
            >
              <label>Chọn tổ nhận tin</label>
              <MultiSelect
                id="civilGroup"
                v-model="selectCivilGroup"
                :options="listCivilGroup"
                optionLabel="civilGroupName"
                placeholder="Chọn một hoặc nhiều tổ"
                :filter="true"
                display="chip"
              />
            </div>
            <div class="min-w-0 md:col-span-12">
              <label>Nội dung tin nhắn</label>
              <Textarea
                id="message"
                type="text"
                v-model="message.mess"
                placeholder="Nhập nội dung tin nhắn"
                class="min-h-[112px]"
              />
            </div>
            <div class="mt-1 flex items-center md:col-span-12">
              <Button
                label="Gởi tin nhắn"
                icon="pi pi-plus-circle"
                iconPos="left"
                @click="doSendMessage()"
                :loading="loadingBar"
                :disabled="!valid()"
              />
            </div>
          </div>
        </div>
      </div>
    </TabPanel>
    <TabPanel header="Gởi tin nhắn theo mẫu đính kèm">
      <div id="tabs_tn2" class="py-1">
        <div class="w-full p-0">
          <div
            class="mb-4 grid grid-cols-1 gap-[18px] items-start md:grid-cols-12"
          >
            <div class="flex min-w-0 flex-col md:col-span-6">
              <label>Lựa chọn phạm vi gởi tin nhắn</label>
              <Dropdown
                id="kind2"
                v-model="action2"
                :options="lsAction"
                optionLabel="label"
                optionValue="value"
              >
              </Dropdown>
            </div>
            <div
              class="flex min-w-0 flex-col md:col-span-6"
              v-if="action == 'location'"
            >
              <label>Lựa chọn khu vực gởi tin</label>
              <Dropdown
                id="location2"
                v-model="province2"
                :options="listProvince"
                optionLabel="provinceName"
                optionValue="provinceCode"
                :filter="true"
                :showClear="true"
              >
              </Dropdown>
            </div>
            <div
              class="flex min-w-0 flex-col md:col-span-6"
              v-if="action2 == 'gender'"
            >
              <label>A3. Giới tính </label>
              <div
                class="flex min-h-[42px] items-center gap-4 rounded-lg border border-slate-300 bg-white px-3"
              >
                <div class="flex items-center gap-2">
                  <input
                    class="m-0 h-4 w-4 accent-teal-600"
                    type="radio"
                    id="nam2"
                    name="sex"
                    value="Nam"
                    v-model="gender2"
                  />
                  <label
                    for="nam2"
                    class="m-0 min-h-0 font-semibold leading-none text-slate-900"
                    >Nam</label
                  >
                </div>
                <div class="flex items-center gap-2">
                  <input
                    class="m-0 h-4 w-4 accent-teal-600"
                    type="radio"
                    id="nu2"
                    name="sex"
                    value="Nữ"
                    v-model="gender2"
                  />
                  <label
                    for="nu2"
                    class="m-0 min-h-0 font-semibold leading-none text-slate-900"
                    >Nữ</label
                  >
                </div>
              </div>
            </div>
            <div
              class="flex min-w-0 flex-col md:col-span-6"
              v-if="action2 == 'customer'"
            >
              <label>Chọn khách hàng gởi</label>
              <MultiSelect
                v-model="listId"
                :options="listCustomer"
                optionLabel="name"
                placeholder="Chọn tài khoản"
                :filter="true"
              >
                <template #option="slotProps">
                  <div class="flex items-center gap-2">
                    <img
                      v-if="slotProps.option.imageUrl"
                      :src="slotProps.option.imageUrl"
                      class="h-10 w-10 rounded-md object-cover"
                    />
                    <label class="m-0 font-medium text-slate-800">{{
                      slotProps.option.name
                    }}</label>
                  </div>
                </template>
              </MultiSelect>
              <!--              <small id="id-note2" class="block min-h-[18px] text-xs font-medium text-red-500"-->
              <!--                >* Vui lòng chọn danh sách khách hàng gởi</small-->
              <!--              >-->
            </div>
            <div
              class="flex min-w-0 flex-col md:col-span-6"
              v-if="action2 == 'group'"
            >
              <label>Lựa chọn nhóm gởi tin</label>
              <Dropdown
                id="group2"
                v-model="idGroup2"
                :options="listGroup"
                optionLabel="groupName"
                optionValue="id"
                :filter="true"
                :showClear="true"
              >
              </Dropdown>
            </div>
            <div
              class="flex min-w-0 flex-col md:col-span-6"
              v-if="action2 == 'civilgroup'"
            >
              <label>Chọn tổ nhận tin</label>
              <MultiSelect
                id="civilGroup2"
                v-model="selectCivilGroup2"
                :options="listCivilGroup"
                optionLabel="civilGroupName"
                placeholder="Chọn một hoặc nhiều tổ"
                :filter="true"
                display="chip"
              />
            </div>
            <div
              class="flex min-w-0 flex-col md:col-span-6"
              v-if="action2 == 'age'"
            >
              <label>Chọn phạm vi độ tuổi: {{ age2 }}</label>
              <h5></h5>
              <Slider v-model="age2" :range="true" />
            </div>
            <!--            <div class="min-w-0 md:col-span-12">-->
            <!--              <label>Nội dung tin nhắn</label>-->
            <!--              <Textarea id="message" type="text" v-model="message.mess" class="min-h-[112px]"/>  -->
            <!--            </div>-->
            <!--            <div class="mt-1 flex items-center md:col-span-12">-->
            <!--              <Button label="Gởi tin nhắn" icon="pi pi-plus-circle" iconPos="left" @click="doSendMessage()" :disabled="!valid()"/>-->
            <!--            </div>-->
          </div>
          <div
            class="grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1fr)_360px]"
          >
            <div class="flex flex-col gap-4">
              <Panel header="Thiết kế khung chính của tin nhắn">
                <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
                  <div class="flex min-w-0 flex-col md:col-span-12">
                    <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
                      <div class="flex min-w-0 flex-col md:col-span-6">
                        <label>Tiêu đề của khung chính</label>
                        <Textarea
                          id="titleMain"
                          type="text"
                          v-model="element1.title"
                          placeholder="Nhập tiêu đề khung chính"
                        />
                      </div>
                      <div class="flex min-w-0 flex-col md:col-span-6">
                        <label>Nội dung khung chính</label>
                        <Textarea
                          id="subtitleMain"
                          type="text"
                          v-model="element1.subtitle"
                          placeholder="Nhập nội dung khung chính"
                        />
                      </div>
                      <div class="flex min-w-0 flex-col md:col-span-6">
                        <label>Đường dẫn hình ảnh chính</label>
                        <div class="flex w-full items-center gap-2">
                          <InputText
                            id="imageUrlMain"
                            type="text"
                            v-model="element1.image_url"
                            placeholder="Chọn hoặc nhập đường dẫn hình ảnh chính"
                          />
                          <Button
                            label="Chọn hình"
                            icon="pi pi-image"
                            iconPos="left"
                            @click="showListImage(1)"
                          />
                        </div>
                      </div>
                      <div class="flex min-w-0 flex-col md:col-span-6">
                        <label>Đường dẫn khung chính</label>
                        <InputText
                          id="defaultUrl"
                          type="text"
                          v-model="element1.url"
                          placeholder="Nhập đường dẫn khi người dùng bấm vào khung chính"
                        />
                      </div>
                      <div
                        class="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm font-medium text-amber-800 md:col-span-12"
                      >
                        <span class="pi pi-info-circle mt-0.5"></span>
                        <span
                          >Lưu ý: Các trường trong khung chính bắt buộc phải
                          nhập.</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </Panel>
              <Panel header="Thiết kế thành phần">
                <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
                  <div class="flex min-w-0 flex-col md:col-span-12">
                    <Accordion :multiple="true" :activeIndex="[0, 1]">
                      <AccordionTab header="Tham số 1">
                        <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
                          <div class="flex min-w-0 flex-col md:col-span-6">
                            <label>Tiêu đề của tham số 1</label>
                            <InputText
                              id="title1"
                              type="text"
                              v-model="element2.title"
                              placeholder="Nhập tiêu đề tham số 1"
                            />
                          </div>
                          <div class="flex min-w-0 flex-col md:col-span-6">
                            <label>Đường dẫn hình ảnh của tham số 1</label>
                            <div class="flex w-full items-center gap-2">
                              <InputText
                                id="imageUrl1"
                                type="text"
                                v-model="element2.image_url"
                                placeholder="Chọn hoặc nhập đường dẫn hình ảnh tham số 1"
                              />
                              <Button
                                label="Chọn hình"
                                icon="pi pi-image"
                                iconPos="left"
                                @click="showListImage(2)"
                              />
                            </div>
                          </div>
                          <div class="flex min-w-0 flex-col md:col-span-6">
                            <label>Loại hành động tham số 1</label>
                            <Dropdown
                              v-model="element2.type"
                              :options="list"
                              optionLabel="label"
                              optionValue="param"
                              showClear="true"
                            ></Dropdown>
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element2.type == 1"
                          >
                            <label>Đường dẫn của tham số 1</label>
                            <InputText
                              id="defaultUrl1"
                              type="text"
                              v-model="element2.url"
                              placeholder="Nhập đường dẫn của tham số 1"
                            />
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element2.type == 2 || element2.type == 3"
                          >
                            <label>Nội dung tin nhắn của tham số 1</label>
                            <InputText
                              id="automessage"
                              type="text"
                              v-model="element2.payload"
                              placeholder="Nhập nội dung tin nhắn của tham số 1"
                            />
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element2.type == 4"
                          >
                            <label>Nội dung tin nhắn sms 1</label>
                            <InputText
                              id="smscontent"
                              type="text"
                              v-model="payload1.content"
                              placeholder="Nhập nội dung SMS tham số 1"
                            />
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element2.type == 4 || element2.type == 5"
                          >
                            <label>Thông tin số điện thoại 1</label>
                            <!-- <InputNumber
                              id="phonenumber"
                              type="text"
                              v-model="payload1.phone_code"
                              mode="decimal"
                              :useGrouping="false"
                            /> -->
                            <InputMask
                              mask="(9999)999999"
                              v-model="payload1.phone_code"
                              placeholder="Nhập số điện thoại"
                            />
                          </div>
                        </div>
                      </AccordionTab>
                      <AccordionTab header="Tham số 2">
                        <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
                          <div class="flex min-w-0 flex-col md:col-span-6">
                            <label>Tiêu đề của tham số 2</label>
                            <InputText
                              id="title2"
                              type="text"
                              v-model="element3.title"
                              placeholder="Nhập tiêu đề tham số 2"
                            />
                          </div>
                          <div class="flex min-w-0 flex-col md:col-span-6">
                            <label>Đường dẫn hình ảnh của tham số 2</label>
                            <div class="flex w-full items-center gap-2">
                              <InputText
                                id="imageUrl2"
                                type="text"
                                v-model="element3.image_url"
                                placeholder="Chọn hoặc nhập đường dẫn hình ảnh tham số 2"
                              />
                              <Button
                                label="Chọn hình"
                                icon="pi pi-image"
                                iconPos="left"
                                @click="showListImage(3)"
                              />
                            </div>
                          </div>
                          <div class="flex min-w-0 flex-col md:col-span-6">
                            <label>Loại hành động tham số 2</label>
                            <Dropdown
                              v-model="element3.type"
                              :options="list"
                              optionLabel="label"
                              optionValue="param"
                              showClear="true"
                            ></Dropdown>
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element3.type == 1"
                          >
                            <label>Đường dẫn của tham số 2</label>
                            <InputText
                              id="defaultUrl2"
                              type="text"
                              v-model="element3.url"
                              placeholder="Nhập đường dẫn của tham số 2"
                            />
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element3.type == 2 || element3.type == 3"
                          >
                            <label>Nội dung tin nhắn của tham số 2</label>
                            <InputText
                              id="automessage2"
                              type="text"
                              v-model="element3.payload"
                              placeholder="Nhập nội dung tin nhắn của tham số 2"
                            />
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element3.type == 4"
                          >
                            <label>Nội dung tin nhắn sms 2</label>
                            <InputText
                              id="smscontent2"
                              type="text"
                              v-model="payload2.content"
                              placeholder="Nhập nội dung SMS tham số 2"
                            />
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element3.type == 4 || element3.type == 5"
                          >
                            <label>Thông tin số điện thoại 2</label>
                            <InputMask
                              mask="(9999)999999"
                              v-model="payload2.phone_code"
                              placeholder="Nhập số điện thoại"
                            />
                          </div>
                        </div>
                      </AccordionTab>
                      <AccordionTab header="Tham số 3">
                        <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
                          <div class="flex min-w-0 flex-col md:col-span-6">
                            <label>Tiêu đề của tham số 3</label>
                            <InputText
                              id="title3"
                              type="text"
                              v-model="element4.title"
                              placeholder="Nhập tiêu đề tham số 3"
                            />
                          </div>
                          <div class="flex min-w-0 flex-col md:col-span-6">
                            <label>Đường dẫn hình ảnh của tham số 3</label>
                            <div class="flex w-full items-center gap-2">
                              <InputText
                                id="imageUrl3"
                                type="text"
                                v-model="element4.image_url"
                                placeholder="Chọn hoặc nhập đường dẫn hình ảnh tham số 3"
                              />
                              <Button
                                label="Chọn hình"
                                icon="pi pi-image"
                                iconPos="left"
                                @click="showListImage(4)"
                              />
                            </div>
                          </div>
                          <div class="flex min-w-0 flex-col md:col-span-6">
                            <label>Loại hành động tham số 3</label>
                            <Dropdown
                              v-model="element4.type"
                              :options="list"
                              optionLabel="label"
                              optionValue="param"
                              showClear="true"
                            ></Dropdown>
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element4.type == 1"
                          >
                            <label>Đường dẫn của tham số 3</label>
                            <InputText
                              id="defaultUrl3"
                              type="text"
                              v-model="element4.url"
                              placeholder="Nhập đường dẫn của tham số 3"
                            />
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element4.type == 2 || element4.type == 3"
                          >
                            <label>Nội dung tin nhắn của tham số 3</label>
                            <InputText
                              id="automessage3"
                              type="text"
                              v-model="element4.payload"
                              placeholder="Nhập nội dung tin nhắn của tham số 3"
                            />
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element4.type == 4"
                          >
                            <label>Nội dung tin nhắn sms 3</label>
                            <InputText
                              id="smscontent3"
                              type="text"
                              v-model="payload3.content"
                              placeholder="Nhập nội dung SMS tham số 3"
                            />
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element4.type == 4 || element4.type == 5"
                          >
                            <label>Thông tin số điện thoại 3</label>
                            <InputMask
                              mask="(9999)999999"
                              v-model="payload3.phone_code"
                              placeholder="Nhập số điện thoại"
                            />
                          </div>
                        </div>
                      </AccordionTab>
                      <AccordionTab header="Tham số 4">
                        <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
                          <div class="flex min-w-0 flex-col md:col-span-6">
                            <label>Tiêu đề của tham số 4</label>
                            <InputText
                              id="title4"
                              type="text"
                              v-model="element5.title"
                              placeholder="Nhập tiêu đề tham số 4"
                            />
                          </div>
                          <div class="flex min-w-0 flex-col md:col-span-6">
                            <label>Đường dẫn hình ảnh của tham số 4</label>
                            <div class="flex w-full items-center gap-2">
                              <InputText
                                id="imageUrl4"
                                type="text"
                                v-model="element5.image_url"
                                placeholder="Chọn hoặc nhập đường dẫn hình ảnh tham số 4"
                              />
                              <Button
                                label="Chọn hình"
                                icon="pi pi-image"
                                iconPos="left"
                                @click="showListImage(5)"
                              />
                            </div>
                          </div>
                          <div class="flex min-w-0 flex-col md:col-span-6">
                            <label>Loại hành động tham số 4</label>
                            <Dropdown
                              v-model="element5.type"
                              :options="list"
                              optionLabel="label"
                              optionValue="param"
                              showClear="true"
                            ></Dropdown>
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element5.type == 1"
                          >
                            <label>Đường dẫn của tham số 4</label>
                            <InputText
                              id="defaultUrl4"
                              type="text"
                              v-model="element5.url"
                              placeholder="Nhập đường dẫn của tham số 4"
                            />
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element5.type == 2 || element5.type == 3"
                          >
                            <label>Nội dung tin nhắn của tham số 4</label>
                            <InputText
                              id="automessage4"
                              type="text"
                              v-model="element5.payload"
                              placeholder="Nhập nội dung tin nhắn của tham số 4"
                            />
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element5.type == 4"
                          >
                            <label>Nội dung tin nhắn sms 4</label>
                            <InputText
                              id="smscontent4"
                              type="text"
                              v-model="payload4.content"
                              placeholder="Nhập nội dung SMS tham số 4"
                            />
                          </div>
                          <div
                            class="flex min-w-0 flex-col md:col-span-6"
                            v-if="element5.type == 4 || element5.type == 5"
                          >
                            <label>Thông tin số điện thoại 4</label>
                            <InputMask
                              mask="(9999)999999"
                              v-model="payload4.phone_code"
                              placeholder="Nhập số điện thoại"
                            />
                          </div>
                        </div>
                      </AccordionTab>
                    </Accordion>
                  </div>
                </div>
              </Panel>
              <div class="mt-1 flex items-center">
                <Button
                  label="Gởi tin nhắn"
                  icon="pi pi-plus-circle"
                  iconPos="left"
                  @click="doSendMessageWithAttachment()"
                  :loading="loadingBar"
                  :disabled="!valid2()"
                />
              </div>
            </div>
            <aside class="xl:sticky xl:top-24 xl:self-start">
              <div
                class="rounded-lg border border-slate-200 bg-white p-4 shadow-[0_12px_30px_rgba(15,23,42,0.08)]"
              >
                <div class="mb-3 flex items-center justify-between">
                  <div>
                    <div class="text-[15px] font-extrabold text-slate-900">
                      Xem trước tin nhắn sẽ được gởi
                    </div>
                    <div class="text-[13px] font-medium text-slate-500">
                      Cập nhật theo nội dung đang nhập
                    </div>
                  </div>
                  <span
                    class="inline-flex h-8 w-8 items-center justify-center rounded-full bg-teal-50 text-teal-700"
                  >
                    <i class="pi pi-mobile text-sm"></i>
                  </span>
                </div>

                <div
                  class="mx-auto w-full max-w-[320px] overflow-hidden rounded-[20px] border border-slate-300 bg-slate-100 shadow-lg"
                >
                  <div
                    class="flex h-10 items-center gap-2 bg-teal-700 px-3 text-white"
                  >
                    <i class="pi pi-chevron-left text-xs"></i>
                    <div class="min-w-0 flex-1 truncate text-[13px] font-bold">
                      Zalo OA Preview
                    </div>
                    <i class="pi pi-ellipsis-h text-xs"></i>
                  </div>

                  <div class="bg-white">
                    <div class="aspect-[16/9] bg-slate-200">
                      <img
                        v-if="element1.image_url"
                        :src="element1.image_url"
                        class="h-full w-full object-cover"
                        alt=""
                      />
                      <div
                        v-else
                        class="flex h-full w-full flex-col items-center justify-center gap-2 text-slate-400"
                      >
                        <i class="pi pi-image text-2xl"></i>
                        <span class="text-[13px] font-semibold">Ảnh chính</span>
                      </div>
                    </div>

                    <div class="border-b border-slate-100 p-3">
                      <div
                        class="line-clamp-2 text-[15px] font-extrabold leading-5 text-slate-900"
                      >
                        {{ element1.title || "Tiêu đề khung chính" }}
                      </div>
                      <div
                        class="mt-1 line-clamp-3 text-[13px] leading-5 text-slate-600"
                      >
                        {{
                          element1.subtitle ||
                          "Nội dung khung chính sẽ hiển thị tại đây."
                        }}
                      </div>
                    </div>

                    <div class="divide-y divide-slate-100">
                      <div
                        v-for="item in previewElements"
                        :key="item.key"
                        class="flex gap-3 p-3"
                      >
                        <div
                          class="h-12 w-12 shrink-0 overflow-hidden rounded-md bg-slate-100"
                        >
                          <img
                            v-if="item.image_url"
                            :src="item.image_url"
                            class="h-full w-full object-cover"
                            alt=""
                          />
                          <div
                            v-else
                            class="flex h-full w-full items-center justify-center text-slate-400"
                          >
                            <i class="pi pi-image text-sm"></i>
                          </div>
                        </div>
                        <div class="min-w-0 flex-1">
                          <div
                            class="line-clamp-2 text-[13px] font-bold leading-5 text-slate-900"
                          >
                            {{ item.title || item.fallbackTitle }}
                          </div>
                          <div
                            v-if="item.description"
                            class="mt-0.5 line-clamp-2 text-xs leading-4 text-slate-500"
                          >
                            {{ item.description }}
                          </div>
                        </div>
                      </div>

                      <div
                        v-if="previewElements.length === 0"
                        class="p-3 text-[13px] font-medium leading-5 text-slate-500"
                      >
                        Các tham số sẽ hiển thị tại đây sau khi nhập tiêu đề
                        hoặc chọn ảnh.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </TabPanel>
  </TabView>

  <div class="contents">
    <div class="w-full">
      <Dialog header="Gởi tin nhắn" v-model:visible="loadingBar">
        <div id="loading">
          <label>Đang gởi tin nhắn, vui lòng chờ ...</label>
          <ProgressBar mode="indeterminate" class="h-[0.3em]" />
        </div>
      </Dialog>
      <ConfirmDialog></ConfirmDialog>
    </div>

    <!-- Dialog chọn hình ảnh; ẩn hoàn toàn wrapper khi không dùng để tránh khung trắng -->
    <div class="w-full" v-if="show">
      <Dialog header="Tập tin lưu trên máy chủ" v-model:visible="show">
        <div class="mb-5 flex flex-col gap-4 md:flex-row md:items-center">
          <div class="min-w-0 flex-1">
            <InputText
              id="find"
              type="text"
              v-model="find"
              @input="search($event)"
              placeholder="Tìm kiếm"
            />
          </div>
          <div class="flex flex-wrap items-center gap-2">
            <Button
              label="Xóa hình"
              @click="deleteImage"
              icon="pi pi-trash"
              class="w-fit"
              :disabled="!validImageSelect()"
            />
            <Button
              label="Upload ảnh"
              icon="pi pi-upload"
              outlined
              class="w-fit"
              @click="openUploadImageDialog"
            />
          </div>
        </div>
        <DataView
          :value="listImageFull"
          :layout="layout"
          :paginator="true"
          :rows="20"
          :sortOrder="sortOrder"
          :sortField="sortField"
        >
          <template #grid="slotProps">
            <div
              class="group flex h-full min-w-0 flex-col rounded-lg border border-slate-200 bg-white p-3 shadow-sm transition hover:border-teal-200 hover:shadow-md"
            >
              <button
                type="button"
                class="flex aspect-[4/3] w-full items-center justify-center overflow-hidden rounded-lg bg-slate-100"
                @click="imageClick(slotProps.data.link)"
              >
                <img
                  class="h-full w-full object-cover transition group-hover:scale-[1.02]"
                  :src="slotProps.data.link"
                  alt=""
                />
              </button>
              <div
                class="mt-2 line-clamp-2 min-h-[32px] break-words text-xs font-medium leading-4 text-slate-700"
                :title="slotProps.data.fileName"
              >
                {{ slotProps.data.fileName }}
              </div>
              <div class="mt-3 flex items-center gap-2">
                <Checkbox v-model="slotProps.data.delete" :binary="true" />
                <span class="text-xs font-medium text-slate-500">Chọn</span>
              </div>
            </div>
          </template>
        </DataView>
      </Dialog>

      <Dialog
        header="Upload ảnh từ máy của bạn"
        v-model:visible="showUploadImageDialog"
        modal
        :style="{ width: 'min(720px, calc(100vw - 32px))' }"
      >
        <div class="flex flex-col gap-4">
          <button
            type="button"
            class="flex min-h-[180px] flex-col items-center justify-center gap-3 rounded-lg border-2 border-dashed border-slate-300 bg-slate-50 px-4 py-6 text-center transition hover:border-teal-400 hover:bg-teal-50/40"
            @click="triggerLocalImagePicker"
            @dragover.prevent
            @drop.prevent="handleImageDrop"
          >
            <span
              class="inline-flex h-12 w-12 items-center justify-center rounded-lg bg-teal-50 text-xl text-teal-700"
            >
              <i class="pi pi-cloud-upload"></i>
            </span>
            <span class="text-[15px] font-bold text-slate-900">
              Kéo ảnh vào đây hoặc bấm để chọn ảnh
            </span>
            <span class="text-sm font-medium text-slate-500">
              Hỗ trợ JPG, JPEG, PNG. Có thể chọn nhiều ảnh cùng lúc.
            </span>
          </button>

          <input
            ref="uploadImageInputEl"
            type="file"
            class="hidden"
            accept=".jpeg,.png,.jpg"
            multiple
            @change="handleUploadImageInputChange"
            :disabled="uploadingImages"
          />

          <div
            v-if="listFileName.length"
            class="overflow-hidden rounded-lg border border-slate-200"
          >
            <div
              class="flex items-center justify-between gap-3 border-b border-slate-200 bg-slate-50 px-4 py-3"
            >
              <div class="text-sm font-bold text-slate-900">
                Tệp tin đã chọn
              </div>
              <Button
                label="Xóa tất cả"
                icon="pi pi-trash"
                severity="danger"
                text
                @click="clearUploadFiles"
                :disabled="uploadingImages"
              />
            </div>
            <div class="divide-y divide-slate-100">
              <div
                v-for="file in listFileName"
                :key="file.nameFile"
                class="flex items-center justify-between gap-3 px-4 py-3"
              >
                <div class="flex min-w-0 items-center gap-3">
                  <span
                    class="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-teal-50 text-teal-700"
                  >
                    <i class="pi pi-image"></i>
                  </span>
                  <div class="min-w-0">
                    <div class="truncate text-sm font-semibold text-slate-900">
                      {{ file.nameFile }}
                    </div>
                    <div class="text-xs font-medium text-slate-500">
                      {{ formatFileSize(file.value?.size) }}
                    </div>
                  </div>
                </div>
                <Button
                  label="Xóa"
                  icon="pi pi-trash"
                  severity="danger"
                  outlined
                  class="!min-h-[34px] px-3 py-1.5"
                  @click="deleteUploadFile(file.nameFile)"
                  :disabled="uploadingImages"
                />
              </div>
            </div>
          </div>
        </div>

        <template #footer>
          <div class="flex justify-end gap-2">
            <Button
              label="Hủy"
              icon="pi pi-times"
              severity="secondary"
              outlined
              @click="closeUploadImageDialog"
              :disabled="uploadingImages"
            />
            <Button
              label="Đăng ảnh"
              icon="pi pi-cloud-upload"
              @click="upload"
              :loading="uploadingImages"
              :disabled="uploadingImages || listFileName.length < 1"
            />
          </div>
        </template>
      </Dialog>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, ref } from "vue";
import ZaloRepository from "@/services/ZaloRepository";
import { useToast } from "@/ui/services/toast";
import { useRouter } from "vue-router";
import { Register } from "../models/register";
import { useStore } from "vuex";
import TeamRepository from "../services/TeamRepository";
import { Team } from "@/models/team.models";
import { Message } from "@/models/message";
import { MessageWithAttachment } from "@/models/messageWithAttachment";
import { ElementParamater } from "@/models/elementParamater";
import { ListCustomer } from "@/models/listCustomer";
import Province from "@/models/province.models";
import { ListImage } from "@/models/listImage";
import { ListImageFull } from "@/models/listImageFull";
import { Group } from "@/models/group";
import teamRepository from "../services/TeamRepository";
import { FileDetail } from "@/models/fileDetail.models";
import axios from "axios";
import zaloRepository from "@/services/ZaloRepository";
import CivilGroup from "@/models/CivilGroup.models";

export default {
  setup() {
    const router = useRouter();
    const register = ref({} as Register);
    const toast = useToast();
    const store = useStore();
    const error = ref(null);
    const message = ref({} as Message);
    const messageWithAttachment = ref({} as MessageWithAttachment);
    const element1 = ref({} as ElementParamater);
    const element2 = ref({} as ElementParamater);
    const element3 = ref({} as ElementParamater);
    const element4 = ref({} as ElementParamater);
    const element5 = ref({} as ElementParamater);
    const listId = ref([] as ListCustomer[]);
    const listIdMessage = ref([] as ListCustomer[]);
    const loadingBar = ref(false);
    const action = ref("");
    const gender = ref("");
    const age = ref([10, 100]);
    const action2 = ref("");
    const gender2 = ref("");
    const age2 = ref([10, 100]);
    const find = ref("");
    const lsAction = ref([
      { label: "Gửi tin nhắn cho từng khách hàng", value: "customer" },
      { label: "Gửi tin nhắn cho tất cả khách hàng", value: "all" },
      { label: "Gửi tin nhắn theo giới tính", value: "gender" },
      { label: "Gửi tin nhắn theo độ tuổi", value: "age" },
      // {label: 'Gửi tin nhắn theo khu vực', value: 'location'},
      { label: "Gửi tin nhắn theo nhóm", value: "group" },
      { label: "Gửi tin nhắn theo tổ", value: "civilgroup" },
    ]);
    const list = ref([
      { label: "mở 1 đường dẫn", value: "oa.open.url", param: 1 },
      { label: "gửi 1 tin nhắn đến OA", value: "oa.query.show", param: 2 },
      { label: "gửi 1 tin nhắn ẩn đến OA", value: "oa.query.hide", param: 3 },
      {
        label: "mở ứng dụng gửi sms với nội dung và sdt cho sẵn",
        value: "oa.open.sms",
        param: 4,
      },
      {
        label: "mở ứng dụng gọi điện thoại với số cho sẵn",
        value: "oa.open.phone",
        param: 5,
      },
    ]);
    const listdefault = ref([
      { label: "mở 1 đường dẫn", value: "oa.open.url", param: 1 },
    ]);
    const payload1 = ref({ content: "", phone_code: "" });
    const payload2 = ref({ content: "", phone_code: "" });
    const payload3 = ref({ content: "", phone_code: "" });
    const payload4 = ref({ content: "", phone_code: "" });
    const previewElements = computed(() =>
      [
        { key: "param-1", fallbackTitle: "Tham số 1", element: element2.value },
        { key: "param-2", fallbackTitle: "Tham số 2", element: element3.value },
        { key: "param-3", fallbackTitle: "Tham số 3", element: element4.value },
        { key: "param-4", fallbackTitle: "Tham số 4", element: element5.value },
      ]
        .map((item) => ({
          key: item.key,
          fallbackTitle: item.fallbackTitle,
          title: item.element.title || "",
          image_url: item.element.image_url || "",
          description:
            typeof item.element.payload === "string"
              ? item.element.payload
              : item.element.url || "",
        }))
        .filter((item) => item.title || item.image_url || item.description),
    );
    const listCustomer = ref([] as ListCustomer[]);
    const listProvince = ref([] as Province[]);
    const province = ref();
    const province2 = ref();
    const listImageFull = ref([] as ListImageFull[]);
    const listImageFullTemp = ref([] as ListImageFull[]);
    const listGroup = ref([] as Group[]);
    const idGroup = ref(0);
    const selectCivilGroup = ref([] as CivilGroup[]);
    const selectCivilGroup2 = ref([] as CivilGroup[]);
    const idGroup2 = ref(0);
    const listCivilGroup = ref([] as CivilGroup[]);

    if (!!!store.state.token) {
      router.push({
        name: "home",
      });
    }
    // const valid = computed(()=> action.value && message.value.mess);
    const valid = () => {
      return (
        action.value &&
        message.value.mess &&
        (action.value !== "civilgroup" || selectCivilGroup.value.length > 0)
      );
    };
    const valid2 = () => {
      return (
        action2.value &&
        element1.value.title &&
        element1.value.subtitle &&
        element1.value.image_url &&
        element1.value.url &&
        (action2.value !== "civilgroup" || selectCivilGroup2.value.length > 0)
      );
    };
    element1.value.type = "1";

    // const returnValue = (st: any) => {
    //   const value = ref();
    //   value.value = list.value.filter(x => x.param == st);
    //   return value.value.value;
    // }

    zaloRepository
      .getListCivilGroupWithPermission()
      .then((response) => {
        listCivilGroup.value = response.data;
      })
      .catch((err) => {
        toast.add({
          severity: "error",
          summary: "Lỗi",
          detail: err.response?.data || "Không thể tải danh sách tổ",
          life: 2000,
        });
      });

    const getCivilGroupUserId = (civilGroups: CivilGroup[]) =>
      ["civilgroup", ...civilGroups.map((civilGroup) => civilGroup.id)].join(
        ",",
      );

    teamRepository
      .listGroup()
      .then((response) => {
        listGroup.value = response.data;
      })
      .catch((err) => {
        toast.add({
          severity: "error",
          summary: "Lỗi",
          detail: "Lỗi không tìm thấy group",
          life: 2000,
        });
      });

    ZaloRepository.getProvince()
      .then((response) => {
        listProvince.value = response.data;
      })
      .catch((err) => {
        toast.add({
          severity: "error",
          summary: "Lỗi",
          detail: "Lỗi khi tải địa điểm",
          life: 2000,
        });
      });
    ZaloRepository.getListCustomer()
      .then((response) => {
        listCustomer.value = response.data;
      })
      .catch((err) => {
        toast.add({
          severity: "error",
          summary: "Lỗi",
          detail: "Lỗi khi tải danh sách khách hàng",
          life: 2000,
        });
      });
    const doSendMessage = () => {
      if (listIdMessage.value.length < 1 && action.value == "customer") {
        toast.add({
          severity: "error",
          summary: "Lỗi",
          detail: "Vui lòng chọn danh sách khách hàng cần gửi",
          life: 3000,
        });
      } else {
        message.value.userId = "";
        listIdMessage.value.forEach((x) => {
          message.value.userId = message.value.userId + x.id + ",";
        });
        if (action.value == "all") {
          message.value.userId = "all";
        } else if (action.value == "gender") {
          message.value.userId = "gender,";
          if (gender.value == "Nam") {
            message.value.userId = message.value.userId + "1";
          } else {
            message.value.userId = message.value.userId + "0";
          }
        } else if (action.value == "age") {
          message.value.userId = "age,";
          message.value.userId = message.value.userId + age.value[0] + ",";
          message.value.userId = message.value.userId + age.value[1];
        } else if (action.value == "location") {
          message.value.userId = "location," + province.value;
        } else if (action.value == "group") {
          message.value.userId = "group," + idGroup.value;
        } else if (action.value == "civilgroup") {
          message.value.userId = getCivilGroupUserId(selectCivilGroup.value);
        }
        loadingBar.value = true;
        ZaloRepository.sendMessage(message.value)
          .then((response) => {
            const temp = ref({} as Message);
            message.value = temp.value;
            toast.add({
              severity: "success",
              summary: "Gửi tin",
              detail: "Gửi tin nhắn thành công",
              life: 2000,
            });
            loadingBar.value = false;
          })
          .catch((err) => {
            loadingBar.value = false;
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response.data,
              life: 2000,
            });
          });
      }
    };

    const doSendMessageWithAttachment = () => {
      if (listId.value.length < 1 && action2.value == "customer") {
        toast.add({
          severity: "error",
          summary: "Lỗi",
          detail: "Vui lòng chọn danh sách khách hàng cần gửi",
          life: 3000,
        });
      } else {
        messageWithAttachment.value.userId = "";
        listId.value.forEach((x) => {
          messageWithAttachment.value.userId =
            messageWithAttachment.value.userId + x.id + ",";
        });
        if (action2.value == "all") {
          messageWithAttachment.value.userId = "all";
        } else if (action2.value == "gender") {
          messageWithAttachment.value.userId = "gender,";
          if (gender2.value == "Nam") {
            messageWithAttachment.value.userId =
              messageWithAttachment.value.userId + "1";
          } else {
            messageWithAttachment.value.userId =
              messageWithAttachment.value.userId + "0";
          }
        } else if (action2.value == "age") {
          messageWithAttachment.value.userId = "age,";
          messageWithAttachment.value.userId =
            messageWithAttachment.value.userId + age2.value[0] + ",";
          messageWithAttachment.value.userId =
            messageWithAttachment.value.userId + age2.value[1];
        } else if (action2.value == "location") {
          messageWithAttachment.value.userId = "location," + province2.value;
        } else if (action2.value == "group") {
          messageWithAttachment.value.userId = "group," + idGroup2.value;
        } else if (action2.value == "civilgroup") {
          messageWithAttachment.value.userId = getCivilGroupUserId(
            selectCivilGroup2.value,
          );
        }
        loadingBar.value = true;
        const elements = ref([] as ElementParamater[]);
        if (element2.value.type == "4" || element2.value.type == "5")
          element2.value.payload = payload1.value;
        if (element3.value.type == "4" || element3.value.type == "5")
          element3.value.payload = payload2.value;
        if (element4.value.type == "4" || element4.value.type == "5")
          element4.value.payload = payload3.value;
        if (element5.value.type == "4" || element5.value.type == "5")
          element5.value.payload = payload4.value;
        if (element1.value.type != null) elements.value.push(element1.value);
        if (element2.value.type != null) elements.value.push(element2.value);
        if (element3.value.type != null) elements.value.push(element3.value);
        if (element4.value.type != null) elements.value.push(element4.value);
        if (element5.value.type != null) elements.value.push(element5.value);
        const elementstemp = ref([] as ElementParamater[]);
        elements.value.forEach((x) => {
          elementstemp.value.push({
            title: x.title,
            subtitle: x.subtitle,
            image_url: x.image_url,
            type: x.type,
            url: x.url,
            payload: x.payload,
          });
        });
        elementstemp.value.forEach((x) => {
          list.value.filter((y) => {
            if (y.param.toString() == x.type) x.type = y.value;
          });
        });
        messageWithAttachment.value.elements = elementstemp.value;
        ZaloRepository.sendMessageWithAttachmentList(
          messageWithAttachment.value,
        )
          .then((response) => {
            loadingBar.value = false;
            const temp = ref({} as MessageWithAttachment);
            messageWithAttachment.value = temp.value;
            toast.add({
              severity: "success",
              summary: "Gửi tin",
              detail: "Gửi tin nhắn thành công",
              life: 2000,
            });
          })
          .catch((err) => {
            loadingBar.value = false;
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response.data,
              life: 2000,
            });
          });
      }
    };
    const products = ref([] as ListImage[]);
    const layout = ref("grid");
    const show = ref(false);
    const showUploadImageDialog = ref(false);
    const uploadingImages = ref(false);
    const uploadImageInputEl = ref<HTMLInputElement | null>(null);
    const getFileNameFromLink = (link: string) => {
      const normalizedLink = link.replaceAll("\\", "/");
      return normalizedLink.split("/").filter(Boolean).pop() || link;
    };
    const getDeleteNameFromLink = (link: string) => {
      const normalizedLink = link.replaceAll("/", "\\");
      const uploadFolderPrefix = "UploadFolder\\";
      const uploadFolderIndex = normalizedLink
        .toLowerCase()
        .indexOf(uploadFolderPrefix.toLowerCase());

      if (uploadFolderIndex >= 0) {
        return normalizedLink.slice(
          uploadFolderIndex + uploadFolderPrefix.length,
        );
      }

      return getFileNameFromLink(link);
    };
    const getListImage = () => {
      ZaloRepository.getListImage()
        .then((response) => {
          listImageFull.value = [];
          products.value = response.data;
          products.value.forEach((x) => {
            listImageFull.value.push({
              link: x.link,
              fileName: getFileNameFromLink(x.link),
              deleteName: getDeleteNameFromLink(x.link),
              //fileName: x.link,
              delete: false,
            });
          });
          // listImageFull.value.forEach(x =>{
          //   x.link = x.link.replace("wwwroot/UploadFolder\\", "UploadFolder/");
          // });
          listImageFullTemp.value = listImageFull.value;
          products.value.forEach((x) => {
            x.link = "https://localhost:5001/" + x.link;
          });
        })
        .catch((err) => {
          // toast.add({
          //   severity: 'error',
          //   summary: 'Lỗi',
          //   detail:'Lỗi không tìm thấy hình ảnh',
          //   life: 2000
          // });
        });
    };

    getListImage();
    const index = ref(0);

    const imageClick = (link: string) => {
      show.value = false;
      link = link.replace("\\", "/");
      link =
        window.location.href.split(window.location.pathname)[0] +
        "/" +
        link.replace("\\", "/");
      link = link.replaceAll(" ", "%20");
      if (index.value == 2) {
        element2.value.image_url = link;
      } else if (index.value == 3) {
        element3.value.image_url = link;
      } else if (index.value == 4) {
        element4.value.image_url = link;
      } else if (index.value == 5) {
        element5.value.image_url = link;
      } else if (index.value == 1) {
        element1.value.image_url = link;
      }
    };
    const showListImage = (i) => {
      show.value = true;
      index.value = i;
    };
    const search = () => {
      listImageFull.value = listImageFullTemp.value.filter((x) =>
        x.fileName.includes(find.value),
      );
    };

    const deleteImage = () => {
      const listDelect = ref([] as ListImage[]);
      listImageFull.value.forEach((x) => {
        if (x.delete) {
          listDelect.value.push({ link: x.deleteName || x.fileName });
        }
      });
      ZaloRepository.deleteImageFile(listDelect.value)
        .then((response) => {
          toast.add({
            severity: "success",
            summary: "Xóa",
            detail: "Xóa thành công hình ảnh",
            life: 2000,
          });
          listImageFullTemp.value = listImageFull.value.filter(
            (x) => x.delete == false,
          );
          listImageFull.value = listImageFullTemp.value;
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: "Lỗi xóa hình ảnh không thành công",
            life: 2000,
          });
        });
    };
    const validImageSelect = () => {
      if (listImageFull.value.filter((x) => x.delete == true).length > 0) {
        return true;
      } else {
        return false;
      }
    };

    const listLink = ref([] as string[]);
    let listFileName = ref([] as FileDetail[]);

    const upload = () => {
      {
        listLink.value = [];
        var files = new FormData();
        listFileName.value.forEach((x) => {
          files.append("formFiles", x.value, x.nameFile);
        });
        uploadingImages.value = true;
        axios
          .post(`/api/file/Upload`, files, {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            uploadingImages.value = false;
            listFileName.value = [];
            showUploadImageDialog.value = false;
            toast.add({
              severity: "success",
              summary: "Thành công",
              detail: "Tải ảnh lên thành công",
              life: 2000,
            });
            getListImage();
          })
          .catch((err) => {
            uploadingImages.value = false;
            toast.add({
              severity: "error",
              summary: "Lỗi",
              detail: err.response?.data || "Tải ảnh không thành công",
              life: 2500,
            });
          });
      }
    };

    const fileChange = (fileList: FileList | null) => {
      if (!fileList) return;
      var leng = fileList.length;
      for (var i = 0; i < leng; i++) {
        var filetemp = ref({} as FileDetail);
        filetemp.value.nameFile = fileList[i].name;
        filetemp.value.value = fileList[i];
        listFileName.value.push(filetemp.value);
      }
    };

    const handleUploadImageInputChange = (event: Event) => {
      fileChange((event.target as HTMLInputElement).files);
      (event.target as HTMLInputElement).value = "";
    };

    const handleImageDrop = (event: DragEvent) => {
      fileChange(event.dataTransfer?.files || null);
    };

    const openUploadImageDialog = () => {
      showUploadImageDialog.value = true;
    };

    const closeUploadImageDialog = () => {
      if (uploadingImages.value) return;
      showUploadImageDialog.value = false;
    };

    const triggerLocalImagePicker = () => {
      uploadImageInputEl.value?.click();
    };

    const deleteUploadFile = (name: string) => {
      listFileName.value = listFileName.value.filter(
        (file) => file.nameFile !== name,
      );
    };

    const clearUploadFiles = () => {
      listFileName.value = [];
    };

    const formatFileSize = (size?: number) => {
      if (!size) return "";
      if (size < 1024) return `${size} B`;
      if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
      return `${(size / 1024 / 1024).toFixed(1)} MB`;
    };

    return {
      doSendMessage,
      valid,
      message,
      messageWithAttachment,
      doSendMessageWithAttachment,
      element1,
      element2,
      element3,
      element4,
      element5,
      previewElements,
      list,
      payload1,
      payload2,
      payload3,
      payload4,
      listdefault,
      loadingBar,
      listCustomer,
      listId,
      listIdMessage,
      lsAction,
      action,
      gender,
      age,
      listProvince,
      province,
      province2,
      action2,
      gender2,
      age2,
      valid2,
      products,
      layout,
      showListImage,
      imageClick,
      show,
      listImageFull,
      find,
      search,
      validImageSelect,
      deleteImage,
      listGroup,
      idGroup,
      idGroup2,
      listFileName,
      fileChange,
      handleUploadImageInputChange,
      handleImageDrop,
      upload,
      showUploadImageDialog,
      uploadingImages,
      uploadImageInputEl,
      openUploadImageDialog,
      closeUploadImageDialog,
      triggerLocalImagePicker,
      deleteUploadFile,
      clearUploadFiles,
      formatFileSize,
      listCivilGroup,
      selectCivilGroup,
      selectCivilGroup2,
    };
  },
};
</script>
